import React, { useEffect, useState } from "react";
import axios from '../../../services/axios';
import { DownloadOutlined, EyeOutlined, SendOutlined, CheckCircleOutlined, CloseCircleOutlined, CheckCircleTwoTone, HourglassTwoTone, UploadOutlined } from "@ant-design/icons";
import { Form, Select, DatePicker, Pagination, Table, Button, Modal, Card, message, Input, Upload, Radio } from 'antd';
import dayjs from 'dayjs'; 
import moment from "moment";
import { DESIGN_MANAGER, PROJECT_MANAGER, DOCUMENT_CONTROLLER, QUANTITY_SURVEYOR, CONSULTANT_DOCUMENT_CONTROLLER } from "../../../constants/role";
import { useNavigate } from 'react-router-dom';
import { CONTRACTOR, CONSULTANT, EMPLOYER } from "../../../constants/userType";

const { Option } = Select;

const ViewPaymentApplication = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [documents, setDocuments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeline, setTimeline] = useState(dayjs().add(1, 'day').format("YYYY-MM-DD"));
  const [selectedFile, setSelectedFile] = useState(null);
  const [pendingCount, setPendingCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [originalDocUrl, setOriginalDocUrl] = useState(null);
  const [isComparisonView, setIsComparisonView] = useState(false);
  const [activeStatus, setActiveStatus] = useState("Pending");
  const [rejectReason, setRejectReason] = useState("");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isRejectLoading, setIsRejectLoading] = useState(false); 
  const user = localStorage.getItem('user');
  const role = JSON.parse(localStorage.getItem('role'))[0];
  const projectName = JSON.parse(localStorage.getItem('Project'))        
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [approvalType, setApprovalType] = useState("approve");
  const [approvalComment, setApprovalComment] = useState("");
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem('userType');
  const [selectedRole, setSelectedRole] = useState(null);

  const handleDownload = (file) => {
    if (!file) {
      console.error("File is undefined or null");
      return;
    }
    
  fetch(file)
    .then(response => response.blob()) 
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const temp = file[file.length - 1];
      link.download = temp.split("/").pop(); 
      link.click();
      window.URL.revokeObjectURL(url); 
    })
    .catch(error => console.error("Error downloading file:", error));
  };
    
  const handlePreview = (file, originalDoc = null, isComparison = false) => {
    if (file) {
      const fileToPreview = Array.isArray(file) ? file[file.length - 1] : file;
      setFileUrl(fileToPreview);


      if(isComparison && originalDoc){
        setOriginalDocUrl(originalDoc);
        setIsComparisonView(true);
      } else {
        setOriginalDocUrl(null);
        setIsComparisonView(false);
      }
      setIsModalVisible(true); 
    } else {
      console.error("File URL is invalid or missing.");
    }
  };

  const handleApproveWithComment = () => {
    if (!selectedRecord) return;
    if (approvalType === "approveWithComment" && !approvalComment.trim()) {
      message.error("Please enter a comment before submitting.");
      return;
    }

    approveByRole(selectedRecord.code, approvalComment);

    setSelectedRecord(prev => ({ ...prev, activeStatus: "Approved" }));
    setApprovalComment("");
    fetchDocuments(activeStatus); 
  };

  const handleOpenApproveModal = (record) => {
    setSelectedRecord(record);  
    setIsApproveModalOpen(true);
  }; 

  const handleRejectedDocPreview = (record) => {
    if (record.status === "Rejected" && record.rejectionReasons && 
        record.rejectionReasons[0]?.rejectedDocumentUrl && record.documentUrl) {
      handlePreview(
        record.rejectionReasons[0].rejectedDocumentUrl, 
        record.documentUrl, 
        true
      );
    }
  };

  const handleReupload = (record) => {
    navigate('/home/payment-application',{
      state: { 
        prefillData: {
          originalDocumentCode: record.code,
          documentReference: record.documentReference,
          paymentApplicationReference: record.paymentApplicationReference,
          preliminary: record.preliminary,
          workDone: record.workDone,
          provisionalSum: record.provisionalSum,
          contingency: record.contingency,
          addAdvance: record.addAdvance,
          lessAdvance: record.lessAdvance,
          addMaterialOnSite: record.addMaterialOnSite,
          lessRetention: record.lessRetention,
          lessOtherDeductibles: record.lessOtherDeductibles,
          vat: record.vat,
          grossPayableAmount: record.grossPayableAmount,
        }
      }
      });
  };

      const handleCancel = () => {
        setIsModalVisible(false);
        setIsComparisonView(false);
        setOriginalDocUrl(null); 
      };

      const handleOpenModal = (file) => {
          setSelectedFile(file);
          setIsModalOpen(true);
        if(!role.includes(DOCUMENT_CONTROLLER) && userType === CONTRACTOR){
          sendToUser(file.documentReference);
        } else if(role.includes(CONSULTANT_DOCUMENT_CONTROLLER)){
          getSendToRoles();
        }
      };  
        
        const handleUploadModalOpen = (record) => {
          setSelectedFile(record);
          setIsUploadModalOpen(true);
        }

  const handleModalClose = () => {
    setIsModalOpen(false);
    form.resetFields();
    setSelectedRole(null); 
    setFileList([])
    setTimeline("");
  };

  const handleUploadModalClose = () => {
    setRejectReason('');
    setFileList([]);
    fetchDocuments();
    fetchDocumentCount();
    setSelectedFile(null);
    setIsRejectLoading(false);
    setIsUploadModalOpen(false);
  };

  const sendDocument = async (values) => {
    values.code = selectedFile.code;
    values.user = user;

    if(!values.timeline){
      values.timeline = timeline
    }
   
    try {
      setLoading(true);
      let endpoint = '';

      if (role.includes(CONSULTANT_DOCUMENT_CONTROLLER)) {
        if(DOCUMENT_CONTROLLER.includes(values.sendTo)){
          endpoint = 'send-back-to-dc-payment-application';
        } else {
          endpoint = 'pa-send-to-consultant-users';
        }
      } else {
        endpoint = 'pa-send-to-next-user';
      }

      if(values.sendTo === QUANTITY_SURVEYOR && userType === CONTRACTOR){
        if(values.sendTo === QUANTITY_SURVEYOR){
          await axios.post('send-to-quantity-surveyor-payment-application', values);
        } else {
          let formData = new FormData();

          if (fileList.length === 0) {
            message.warning("Please upload a file.");
            return;
          }
          
          if (fileList.length > 0) {
            formData.append('file', fileList[0].originFileObj);
          }
          const data = { ...values };
          formData.append('data', JSON.stringify(data));

          await axios.post('pa-send-to-documentControllerConsult', formData,{
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            timeout: 60000
          })
        }
      } else {
        await axios.post(endpoint, values);
      }
      message.success('Document sent successfully!');
      handleModalClose();
      fetchDocuments();
      fetchDocumentCount();
      setLoading(false)
    } catch (err) {
      setLoading(false)
     if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong1');
      }
    }
  };

  const approveByRole = async (code) => {
    let endpoint = "";
  
   
    if (userType === CONTRACTOR) {
      endpoint = 'pa-approved-document';
    } else {
      endpoint = "pa-approved-by-consultant";
    } 


  
    try {
      await axios.post(endpoint, { code, comment: approvalComment, user, role: role });
      message.success("Approved Successfully");
      fetchDocuments();
      fetchDocumentCount();
    } catch (err) {
      console.error("error", err);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong5');
      }   
    }
  };

  const fetchDocumentCount = async () => {
    try {
      const res = await axios.post('pa-document-count', { role, user, projectName });
      if (res && res.data) {
          setPendingCount(res.data.pendingCount);
        } 
      if(res && res.data) {
          setApprovedCount(res.data.approvedCount);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong2');
      }    
    }
  };

  const fetchDocuments = async () => {
    try {  
      const res = await axios.post('pa-get-allDocument', { role, user, projectName });
      if (res && res.data && res.data.document && res.data.document) {
        setDocuments(res.data.document);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong3');
      }
    }
  };
  
  
  // const getRoles = async () => {
  //   try {
  //     const res = await axios.post('get-all-roles');
  //     if (res && res.data && res.data.userRoles) {
  //       setRoles(res.data.userRoles);
  //     }
  //   } catch (err) {
  //     if (err.response && err.response.data && err.response.data.msg) {
  //       message.warning(err.response.data.msg);
  //     } else if (err.response && err.response.data && err.response.data.userName) {
  //       message.warning(err.response.data.userName[0]);
  //     } else if (err.response && err.response.status === 401) {
  //       message.error('User not authorised');
  //     } else {
  //       message.error('Something went wrong4');
  //     }
  //   }
  // }  

  const getSendToRoles = async () => {
    try {
      const res = await axios.post('get-send-to-roles', { user });
      if (res && res.data && res.data.userRoles) {
        setRoles(res.data.userRoles);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorised');
      } else {
        message.error('Something went wrong99');
      }
    }
  }



  const handleRejectSubmit = async () => {
    if (!rejectReason.trim()) {
      message.error("Please provide a reason for rejection.");
      return;
    }
    setIsRejectLoading(true)
    try {
      if(userType === CONSULTANT){
        await axios.post('pa-reject-by-consultant', {code: selectedFile.code, role, user, rejectReason:rejectReason});
      } else {
        await axios.post('pa-reject-document', {code: selectedFile.code, role, user, rejectReason:rejectReason});
      }
      message.success( "Rejection submitted successfully!");
      handleUploadModalClose();
    } catch (err) {
      setIsRejectLoading(true)
        if (err.response && err.response.data && err.response.data.msg) {
          message.warning(err.response.data.msg);
        } else if (err.response && err.response.data && err.response.data.userName) {
          message.warning(err.response.data.userName[0]);
        } else if (err.response && err.response.status === 401) {
          message.error('User not authorized');
        } else {
          message.error('Something went wrong reject');
        }
      } finally {
        setIsRejectLoading(false);
      }
  };

  const getUniqueFilters = (key) => {
    return [...new Set(documents.map((doc) => doc[key]))]
    .filter(Boolean)
    .map((value) => ({ text: value, value }));
  };  

  useEffect(() => {
    fetchDocuments();
    fetchDocumentCount();

  }, []) 

  const onCardChange = (type) => {
    setActiveStatus(type);
    fetchDocuments(type)
  }

  const sendToUser = async (documentReference) => {
    try {
      const res = await axios.post('get-send-to-user-payment-application', { user, documentReference });
      if (res && res.data && res.data.nextRole) {
        form.setFieldValue('sendTo', res.data.nextRole);
        setSelectedRole(res.data.nextRole)
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorised');
      } else {
        message.error('Something went wrong');
      }
    }
  }

  const columns = [
    {
      title: "Document Reference",
      dataIndex: "documentReference",
      key: "documentReference",
      width: 200,
      filters: getUniqueFilters('documentReference'),
      onFilter: (value, record) => record.documentReference?.startsWith(value),
      filterSearch: true,
      render: (text, record) => 
        text ? (
        <a
        onClick={() =>
          navigate(`/home/view-payment-application/documentReference/${record.documentReference}`, { state: record })
        }
        className="text-blue-500 hover:underline cursor-pointer"
        >
          {text}
        </a>
        ) : (
          "NA"  
      ),
    },
    {
      title: "Payment Application Reference",
      dataIndex: "paymentApplicationReference",
      key: "paymentApplicationReference",
      width: 150,
      filters: getUniqueFilters('paymentApplicationReference'),
      onFilter: (value, record) => record.paymentApplicationReference?.startsWith(value),
      filterSearch: true,
      ellipsis: true,
    },
    {
      title: "Preliminary",
      dataIndex: "preliminary",
      key: "preliminary",
    },
    {
      title: "Work Done",
      dataIndex: "workDone",
      key: "workDone",
    },
    {
      title: "Provisional Sum",
      dataIndex: "provisionalSum",
      key: "provisionalSum",
    },
    {
      title: "Contingency",
      dataIndex: "contingency",
      key: "contingency",
    },
    {
      title: "Add: Advance",
      dataIndex: "addAdvance",
      key: "addAdvance",
    },
    {
      title: "Less: Advance",
      dataIndex: "lessAdvance",
      key: "lessAdvance",
    },
    {
      title: "Add: Material On Site",
      dataIndex: "addMaterialOnSite",
      key: "addMaterialOnSite",
    },
    {
      title: "Less: Retention",
      dataIndex: "lessRetention",
      key: "lessRetention",
    },
    {
      title: "Less: Other Deductibles",
      dataIndex: "lessOtherDeductibles",
      key: "lessOtherDeductibles",
    },
    {
      title: "VAT @ 5%",
      dataIndex: "vat",
      key: "vat",
    },
    {
      title: "Gross Payable Amount",
      dataIndex: "grossPayableAmount",
      key: "grossPayableAmount",
    },
    {
      title: "Payment Due Date",
      dataIndex: "paymentDueDate",
      key: "paymentDueDate",
      render: (date) => moment(date).format("YYYY-MM-DD"),
    },
    userType !== 'Consultant' && {
      title: 'Version',
      dataIndex: 'version',
      key: 'version',
      width: 130,
      render: (text, record) => text ? text : 'NA'
    },  
    userType === 'Consultant' && {
      title: 'Revision',
      dataIndex: 'revision',
      key: 'revision',
      width: 130,
      render: (text, record) => text ? text : 'NA'
    },   
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      ellipsis: true,
      render: (status) => {
        return <span className={status === "Accepted" ? "text-green-600" : status === "Rejected" ? "text-red-600" : "text-gray-800"}>{status}</span>;
      }
    },
    {
      title: 'WorkFlow Stage',
      dataIndex: 'stage',
      key: 'stage',
      width: 170,
      render: (text, record) => text ? text : 'NA'
    },
    (!role.includes(QUANTITY_SURVEYOR) && !role.includes(DOCUMENT_CONTROLLER)) && {
      title: "Timeline",
      dataIndex: "timelineDetails",
      key: "timelineDetails",
      width: 120,
      render: (timelineDetails) => {
        if (!timelineDetails) return "NA";
         if(timelineDetails){
          return timelineDetails?.[role[0]]?.date ? moment(timelineDetails?.[role].date).format('DD/MM/YYYY') : 'NA'; 
         } else {
           return 'NA'
         }
      }
    },
    role.includes(QUANTITY_SURVEYOR) && {
      title: 'Rejected Documents',
      key: 'rejectDocument',
      render: (text, record) => (
        record.status === "Rejected" ? (
          <div className="flex space-x-2">
            {/* <Button 
              type="primary" 
              onClick={() => handleRejectedDocPreview(record)}
            >
              Compare
            </Button> */}
            <button
              className="reupload-btn"
              onClick={() => handleReupload(record)}
            >
              RE-UPLOAD
            </button>  
          </div>  
        ) : (
          <span>-</span>
        )
      )
    },
    {
      title: 'Actions',
      key: 'actions',
     
      render: (text, record) => (
        <div>
        {/* Download Button */}
        <Button
            icon={<DownloadOutlined />}
            onClick={() => handleDownload(userType === 'Consultant' ? record.docWithTransmittal : record.documentUrl)}
            style={{ backgroundColor: 'white', color: 'blue', marginRight: '10px' }}
          />
 
        {/* Preview Button */}
        <Button
            icon={<EyeOutlined />}
            onClick={() => handlePreview(userType === 'Consultant' ? record.docWithTransmittal : record.documentUrl)}
            style={{ backgroundColor: 'white', color: 'black', marginRight: '10px' }}
          />
 
        {/* Send Button */}
        {record.status !== "Rejected" && !record.status.includes('Approved by Consultant') && 
          (
            (role.includes('Quantity Surveyor') && !record.sentDetails?.[role]?.sent) || 
            (role.includes('Document') && record.timelineDetails?.[role]?.date && !record.sentDetails?.[role]?.sent) ||
            (!role.includes(DOCUMENT_CONTROLLER) && record.approvedDetails?.[role]?.approved && !record?.sentDetails?.[role]?.sent)
          ) && (
            <Button
              icon={<SendOutlined />}
              onClick={() => handleOpenModal(record)}
              style={{ backgroundColor: 'white', color: 'green', marginRight: '10px' }}
            />
        )}
 
        {/* Pending Status Actions */}
          {record.status !== "Rejected" && (
          <>
            {( !role.includes('Quantity Surveyor') && !role.includes('Document') && record.timelineDetails?.[role]?.date && !record.approvedDetails?.[role]?.approved ) && (
              <>
                {/* Approve Button */}
                <Button  
                  icon={<CheckCircleOutlined />}
                  onClick={() => handleOpenApproveModal(record)}  
                  style={{ backgroundColor: 'white', color: 'green', marginRight: '10px' }}
                >
                  
                </Button>

                {/* Reject Button */}
                <Button
                  icon={<CloseCircleOutlined />}
                  onClick={() => handleUploadModalOpen(record)}
                  style={{ backgroundColor: 'white', color: 'red', marginRight: '10px' }}
                />
              </>
            )}
          </>
        )}
      </div>
      ),
    },
  ];

  return (
    <div className="relative flex-1 p-5 overflow-y-auto min-h-screen ml-6 mr-1">
      <div className="max-w-7xl mx-auto">
         <div className="flex space-x-7 mb-6">
            {!(role.includes(QUANTITY_SURVEYOR) || role.includes(DOCUMENT_CONTROLLER)) && (
              <>
                <Card
                  className={`w-56 transition-transform transform hover:scale-105 
                              bg-yellow-50 shadow-xl border-yellow-300 rounded-xl border`}
                >
                <div className="flex items-center space-x-3">
                  <HourglassTwoTone twoToneColor="#FFAA33" style={{ fontSize: "24px" }} />
                  <h2 className="text-lg font-semibold text-yellow-800">Pending</h2>
                </div>
                <p className="text-3xl font-bold text-yellow-800 mt-2">{pendingCount}</p>
                </Card>
                  <Card
                    className={`w-56 transition-transform transform hover:scale-105 
                                bg-teal-50 shadow-xl border-teal-300 rounded-xl border`}
                  >
                    <div className="flex items-center space-x-3">
                      <CheckCircleTwoTone twoToneColor="#30C4A0" style={{ fontSize: "24px" }} />
                      <h2 className="text-lg font-semibold text-teal-800">Approved</h2>
                    </div>
                    <p className="text-3xl font-bold text-teal-800 mt-2">{approvedCount}</p>
                  </Card>
              </>
            )}
          </div>

        {/* <Card className="shadow-md rounded-lg p-6 w-full max-w-9xl mx-auto"> */}
          <div className="overflow-x-auto">
            <Table 
              loading={loading} 
              dataSource={documents} 
              columns={columns.filter((e)=> e !== false)} 
              rowKey="documentReference"
              scroll={{ x: "max-content" }} 
              pagination={{ pageSize: 10 }} 
            />         
          </div>

          <Modal
            title={<div className="text-center">📄 Send Document</div>}
            open={isModalOpen}
            onCancel={handleModalClose}
            footer={null}
            style={{ padding: '20px', maxHeight: '400px', overflowY: 'auto' }}
          >
            <Form form={form} onFinish={sendDocument}
            initialValues={{
              timeline: dayjs().add(1, 'day'), 
            }}>
              {/* Select Roles Form Item */}
              <Form.Item
                label="Send To:"
                name="sendTo"
                rules={[{ required: true, message: 'Please select at least one role' }]}
                style={{ marginBottom: '16px' }}
              >
                {role.includes(DOCUMENT_CONTROLLER)  && userType === CONTRACTOR ? (
                  <Select className="w-full"  onChange={(value) => setSelectedRole(value)}>
                    <>
                      <Option key={CONSULTANT_DOCUMENT_CONTROLLER} value={CONSULTANT_DOCUMENT_CONTROLLER}>
                        {CONSULTANT_DOCUMENT_CONTROLLER}
                      </Option>
                      <Option key={QUANTITY_SURVEYOR} value={QUANTITY_SURVEYOR}>
                        {QUANTITY_SURVEYOR}
                      </Option>
                    </>
                  </Select>
                  ) : role.includes(CONSULTANT_DOCUMENT_CONTROLLER) ? (
                    <Select className="w-full"  mode="multiple">
                      {roles.map((e)=>(
                        <Option key={e.role} value={e.role}>
                        {e.role}
                      </Option>
                      ))}
                    </Select>
                  ) : (
                    <Input readOnly />
                  )}
              </Form.Item>

              {/* Timeline Form Item */}
              {!(role.includes(DOCUMENT_CONTROLLER) || selectedRole?.includes('Document')) && (<Form.Item
                label="Set Date"
                name="timeline"
                rules={[{ required: true, message: 'Please set a timeline' }]}
                style={{ marginBottom: '16px' }} 
              >
                <DatePicker
                  format="YYYY-MM-DD"
                  onChange={(date) => setTimeline(date ? date.format("YYYY-MM-DD") : "")} 
                  style={{ width: '100%' }} 
                  disabledDate={(current) => current && current < dayjs().startOf('day')} // Disable past dates
                />
              </Form.Item>)}

              {(role.includes(DOCUMENT_CONTROLLER) && selectedRole === CONSULTANT_DOCUMENT_CONTROLLER) &&  (<Form.Item label="Upload Transmittal Document" name="file"
                  rules={[{ required: true, message: 'Please upload a transmittal document'}]} >
                    <Upload 
                      fileList={fileList}
                      maxCount={1}
                      beforeUpload={() => false}
                      onChange={({ fileList }) => setFileList(fileList)}
                      className="w-full" 
                    >
                      <Button 
                      icon={<UploadOutlined />}
                      className="w-full h-12 flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white"
                    >
                      Select File
                      </Button>
                    </Upload>
                  </Form.Item>)}
              
              {/* Submit Button */}
              <div className="flex justify-center">
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  className="w-1/4 mt-4" 
                  style={{ backgroundColor: 'green', color: 'white' }} 
                  loading={loading}
                >
                  Send
                </Button>
              </div>
            </Form>
          </Modal>

          <Modal
            title="Approval Options"
            visible={isApproveModalOpen}
            onCancel={() => setIsApproveModalOpen(false)}
            footer={null}        
          >
            <Radio.Group 
              onChange={(e) => setApprovalType(e.target.value)} 
              value={approvalType}
            >
            <Radio value="approve">Approve</Radio>
            <Radio value="approveWithComment">Approve with Comment</Radio>
            </Radio.Group>
      
            {approvalType === "approveWithComment" && (
              <div style={{ marginTop: "10px" }}>
                <Input.TextArea
                  rows={4}
                  placeholder="Enter your comment"
                  value={approvalComment}
                  onChange={(e) => {
                    const comment = e.target.value;
                    setApprovalComment(comment); 
                  }}
                />
              </div>
            )}
            <div className="flex ">
              <Button 
                type="primary" 
                onClick={handleApproveWithComment}
                style={{ marginTop: "10px" }}
              >
                Submit Approval
              </Button>
            </div>
          </Modal>

          <Modal
            title={isComparisonView ? "Document Comparison" : "File Preview"}
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            width={isComparisonView ? 1000 : 800}
            style={{ padding: '0' }}
          >
          {isComparisonView ? (
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-1/2 border-r border-gray-300">
                <div className="bg-gray-100 p-2 text-center font-semibold border-b">Original Document</div>
                <iframe
                src={originalDocUrl}
                          width="100%"
                          height="500px"
                          style={{ border: 'none' }}
                          title="Original Document"
                        />
                        </div>
                        <div className="w-full md:w-1/2">
                         <div className="bg-gray-100 p-2 text-center font-semibold border-b">Rejected Document</div>
                        <iframe
                        src={fileUrl}
                        width="100%"
                        height="500px"
                        style={{ border: 'none' }}
                        title="Rejected Document"
                        />
                        </div>
                        </div>
                        ) : (
                          <iframe
                          src={fileUrl}
                          width="100%"
                          height="500px"
                          style={{ border: 'none' }}
                          title="Document Preview"
                          />
                        )}
          </Modal>

          <Modal
            title="Reject Document"
            visible={isUploadModalOpen}
            onCancel={handleUploadModalClose}
            footer={null}
            destroyOnClose={true}
          >
          <Form layout="vertical" preserve={false}>
          {/* Reason Input */}
          <Form.Item label="Rejection Reason" name="rejectionreason" rules={[{ required: true, message: 'Please provide a reason for rejection' }]}>
            <Input.TextArea
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Enter rejection reason"
              rows={3}
            />
          </Form.Item> 
            {/* File Upload */}
            {!role.includes(DOCUMENT_CONTROLLER) && userType !== CONSULTANT && (<Form.Item label="Upload Edited Document" name="file"
            rules={[{ required: true, message: 'Please upload a support document'}]} >
            <Upload 
              fileList={fileList}
              maxCount={1}
              beforeUpload={() => false}
              onChange={({ fileList }) => setFileList(fileList)}
              className="w-full"
              
            >
              <Button 
              icon={<UploadOutlined />}
              className="w-full h-12 flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white"
            >
              Select File
              </Button>
            </Upload>
          </Form.Item>)}
              
                            {/* Submit Button */}
                            <div className="flex justify-center">
                            <Button 
                              type="primary"  
                              onClick={handleRejectSubmit}
                              className="w-1/4 mt-4" 
                              style={{ backgroundColor: 'red', color: 'white' }}
                            >
                              {isRejectLoading ? 'Uploading...' : 'Submit Rejection'}
                            </Button>
                            </div>
                          </Form>
                        </Modal>
              
            
        {/* </Card> */}

      </div>
    </div>
  );
};

export default ViewPaymentApplication;